<template>
    <div class="app-container">
        <!-- 工具栏 -->
        <div class="filter-container">
            <div class="tips" v-if="source == 'apply'">温馨提示：该功能暂时只对英雄体系内认证用户开放，体系外用户需联系英雄体系内相关同学进行代申请</div>
            <el-input size="small" v-model="findStr" clearable placeholder="申请人/申请游戏模糊查询" style="width:200px;"></el-input>

            <div class="filter-data">
                <div class="label ">流程状态：</div>
                <el-select size="small" v-model="status" filterable clearable placeholder="流程状态" style="width:200px;">
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>

            <el-button size="small" type="primary" icon="el-icon-search" @click="handleFilter" >查询</el-button>

            <!-- table header 筛选 -->
            <div class="filterTableHeader" style="float:right;">
                <el-button size="mini" type="primary" v-if="source == 'apply'" @click="handleApply">发起申请</el-button>
                <el-button size="mini" type="success" style="margin-right: 10px" @click="handleFlow">流程图</el-button>

                <el-popover width="400" trigger="click">
                    <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
                    <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
                        <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item" >{{item[Object.keys(item)[0]]}}</el-checkbox>
                    </el-checkbox-group>
                </el-popover>
            </div>
        </div>

        <!-- 表格 -->
        <el-table class="grayTableTile"  v-loading="listLoading" :data="tableList" border style="width: 100%">
            <el-table-column v-for="(item,index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" :min-width="Object.keys(item)[0] == 'id' ? '80px': Object.keys(item)[0] == 'addTime' ? '130px' : Object.keys(item)[0] == 'approverName' || Object.keys(item)[0] == 'gameName' ? '220px' : '100px' ">
                <template slot-scope="scope" >
                    <span v-if="Object.keys(item)[0] == 'type'"> {{ scope.row[Object.keys(item)[0]] | typeMap}}</span>
                    <span v-else-if="Object.keys(item)[0] == 'status'" :style="scope.row[Object.keys(item)[0]] | colorMap"> {{ scope.row[Object.keys(item)[0]] | statusMap}}</span>
                    <span v-else> {{ scope.row[Object.keys(item)[0]]}}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="100px">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleDetail(scope.row)" type="text">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" @pagination="getList" />

        <!-- 流程图 -->
        <flow-dialog ref="flow"></flow-dialog>

        <!-- 发起申请 -->
        <application ref="apply" @reList="getList"></application>

        <!-- 详情 -->
        <detail ref="details" @reList="getList"></detail>

    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import FlowDialog from './flowDialog'
import Application from './application'
import Detail from './detail'
import {ajax_myApply} from '@Sys~/api/sys'
const defaultApplyThead = [
  {id: '申请ID'},
  {promoterName: '发起人'},
  {applicantName: '申请人'},
  {type: '申请类型'},
  {addTime: '申请时间'},
  {gameName: '申请游戏'},
  {status: '流程状态'},
  {approverName: '流程审批人'}
]

const defaultApproveThead = [
  {id: '申请ID'},
  {promoterName: '发起人'},
  {applicantName: '申请人'},
  {type: '申请类型'},
  {addTime: '申请时间'},
  {gameName: '申请游戏'},
  {status: '流程状态'}
]

export default {
    props: {
        source: {
            type: String
        }
    },
    components: {Pagination, FlowDialog, Application, Detail},
    data() {
        return {
            findStr: '',
            status: null,
            statusOptions: [
                {value: 0, label: '待审核'},{value: 2, label: '正在审核'},{value: 3, label: '被驳回'},{value: 1, label: '已完成'}
            ],

            // 表格
            listLoading: false,
            originalCaseTable:[], // 排序原始数据
            tableList:[],
            tableTheadOptions: this.source == 'apply' ? defaultApplyThead : defaultApproveThead,
            checkboxTitle: this.source == 'apply' ? defaultApplyThead : defaultApproveThead,
            tableTheads: this.source == 'apply' ? defaultApplyThead : defaultApproveThead,
            
            total: 0,
            listQuery: {
                pageNo: 1,
                pageSize: 10
            }
        }
    },

    filters: {
        // 申请类型
        typeMap(type){
            const typeMap = {
              0 : '代理申请',
              1 : '本人申请'
            }
            return typeMap[type]
        },

        // 流程状态
        statusMap(status) {
            const statusMap = {
              0 : '待审核',
              1 : '已完成',
              '-1': '已删除',
              2: '正在审核',
              3: '被驳回'
            }
            return statusMap[status]
        },

        // 不同流程状态对应的颜色
        colorMap(color) {
            const colorMap = {
                0 : 'color:#E6A23C', // 待审核 深黄色
               // 1 : 'color:#67C23A', // 已完成 绿色
               2 : 'color:#409EFF', // 正在审核 蓝色
               3 : 'color:#F56C6C', // 被驳回 红色
                // '-1': 'color:#bababb' // 已删除
            }
            return colorMap[color]
        }
    },

    watch: {
        // 筛选table header
        checkboxTitle(valArr) {
            this.tableTheads = this.tableTheadOptions.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
        }
    },

    created() {
        this.getList()
    },

    methods: {
        // 获取列表
        getList() {
            this.listLoading = true
            const data = {
                page_no: this.listQuery.pageNo,
                page_size: this.listQuery.pageSize,
                findStr: this.findStr,
                status: this.status,
                type: this.source == 'apply' ? 0 : 1,
            }
            ajax_myApply(data).then(response => {
                this.listLoading = false
                if(response.code == 1) {
                    this.tableList = response.data.result
                    this.originalCaseTable = JSON.parse(JSON.stringify(response.data.result))

                    this.total = response.data.totalCount
                } 
            })
        },

        // 查询
        handleFilter() {
            this.listQuery.pageNo = 1
            this.getList()
        },

        // 打开流程图
        handleFlow() {
            this.$refs['flow'].flowDialog = true
        },

        // 发起申请
        handleApply() {
            this.$refs['apply'].init()
        },

        // 查看详情
        handleDetail(row) {
            this.$refs['details'].init(row, this.source)
        }
    }
}
</script>

<style lang="scss" scoped>
.filter-container{

    .filter-data{
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        margin: 0px 10px 0px;
    }
    .label{
        min-width: 77px;
        font-size: 15px;
        margin-right: 3px;
        color: #7b7b7b; 
    }
    .tips {
        width: 100%;
        margin-bottom: 10px;
    }
}

.tips{
    color: #F56C6C;
    font-size: 14px;
}
</style>